module.exports = __webpack_public_path__ + "img/horizontal_4_6_9005.2839a4b6.png";